export enum TOKENS_NAME  {
  APP_DID_SERVICE = 'APP_DID_SERVICE',
  APP_WEB3AUTH_SERVICE = 'APP_WEB3AUTH_SERVICE',
  APP_PINNING_SERVICE_DEFAULT_CONFIG = 'APP_PINNING_SERVICE_DEFAULT_CONFIG',
  APP_WALLET_SERVICE_APIKEYS = 'APP_WALLET_SERVICE_APIKEYS',
  APP_WALLET_UTILS = 'APP_WALLET_UTILS',
  APP_MESSAGING_SERVICE = 'APP_MESSAGING_SERVICE',
  APP_NOTIFICATION_SERVICE = 'APP_NOTIFICATION_SERVICE',
  APP_CERAMIC_SERVICE = 'APP_CERAMIC_SERVICE',
  APP_DATASTORE_SERVICE = 'APP_DATASTORE_SERVICE',
  APP_DID_ENCRYPTION_SERVICE = 'APP_DID_ENCRYPTION_SERVICE',
  APP_ENCRYPTION_SERVICE = 'APP_ENCRYPTION_SERVICE',
  APP_IS_PROD = 'APP_IS_PROD',
  APP_LOADER_SERVICE = 'APP_LOADER_SERVICE',
  APP_PINATA_SERVICE = 'APP_PINATA_SERVICE',
  APP_WEB3STORAGE_SERVICE = 'APP_WEB3STORAGE_SERVICE',
  APP_IPFS_PINNING_SERVICE = 'APP_IPFS_PINNING_SERVICE',
  APP_IPFS_SERVICE = 'APP_IPFS_SERVICE',
  APP_PROMPT_STRATEGY_SERVICE = 'APP_PROMPT_STRATEGY_SERVICE',
  APP_AUTH_APIKEY = 'APP_AUTH_APIKEY',
  APP_HEXA_PUBLICADDRES = 'APP_HEXA_PUBLICADDRES',
}
